import React, { Component } from 'react';

class StackedGraph extends Component {
    
    render() {
       
        return (
            <div className="pb-3">
                <div id="chart" className="noselect px-3 mb-3">
                    <canvas id="myChart" height="6%"></canvas>
                </div>
                <div id="chartjs-legend" className="noselect px-3"></div>
            </div>
        )
    }
}

export default StackedGraph;
